import { DateTime } from "luxon"

import { apiClient, assertOk } from "@/api/generated/client"

import { type Trip } from "../types/logisticsTypes"

import type { DailyDisplayData } from "../types/dailyDisplayTypes"

export const getDailyData = async (): Promise<DailyDisplayData> => {
  const start = DateTime.now().setZone("America/Chicago").startOf("day").toISO()

  const end = DateTime.now()
    .setZone("America/Chicago")
    .startOf("day")
    .plus({ days: 1 })
    .minus({ seconds: 1 })
    .toISO()
  const res = await apiClient.GET("/api/Logistics/trips", {
    params: { query: { TripAggregation: "Daily", Start: start ?? "", End: end ?? "" } },
  })

  const trips = assertOk<Trip[]>(res.response, res.error, res.data)
  if (trips.length > 0) {
    return {
      manure: trips[0].unloadVolume ?? 0,
      uf: trips[0].loadVolume ?? 0,
      loads: trips[0].count ?? 0,
    }
  } else {
    return {
      manure: 0,
      uf: 0,
      loads: 0,
    }
  }
}
